module.exports = __webpack_public_path__ + "static/img/turntable_integral.2bebfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turntable_integral.png
// module id = +LP+
// module chunks = 43